import script from "./BetslipModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BetslipModal.vue?vue&type=script&setup=true&lang=ts"

import "./BetslipModal.vue?vue&type=style&index=0&id=5eb7bb86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eb7bb86"]])

export default __exports__